import * as React from 'react';
import {connect} from 'react-redux';
import {Tab, Tabs, withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {infobankStyle} from './infobank.style';
import ChildInfoList from '@components/childinfo/ChildInfoList';
import SharedNotes from '@components/sharednotes/SharedNotesView';
import ImageFlowContainer from '@components/imageflow/ImageFlowContainer';
import {ISharedNote} from '@app-types/websocket/sharedinfo.types';
import {IFlowPost} from '@app-types/websocket/imageflow.types';
import BottomBar from '@components/calendar2/fab/BottomBar';
import SharedNotesView from '@components/sharednotes/SharedNotesView';
import { getSelectedFamilyResource } from '@services/user/user.utils';
import { RouteComponentProps } from 'react-router-dom';
import { getInitialPane, PaneIndex, toPaneIndex } from '@helpers/horizontalPaneState';
import * as UiActions from '@services/ui/ui.actions';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends RouteComponentProps, WithStyles<typeof infobankStyle> {
  unseenPosts: number;
  unseenAccounts: number;
  sharedAccounts: ISharedNote[];
  isTogether:boolean;
  lastInfoPane: PaneIndex;
  setLastInfoPane: (pane: PaneIndex) => void;
}

interface IState {
  scrollBullet: PaneIndex;
  scrollEndTime: number;
  hideFab:boolean;
}

class InfoBankContainer extends React.Component<IProps, IState> {
  private timer:NodeJS.Timeout|null = null;
  private viewRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);
    this.state = {
      scrollBullet: getInitialPane(props.location && props.location.pathname, "/app/info", props.lastInfoPane),
      scrollEndTime: 0,
      hideFab: false,
    };

  }

  public componentDidMount() {
    this.props.setLastInfoPane(this.state.scrollBullet);
    this.scrollDirect(this.state.scrollBullet);
  }

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const pane = getInitialPane(this.props.location && this.props.location.pathname, "/app/info", this.props.lastInfoPane);
      this.props.setLastInfoPane(pane);
      if (pane !== this.state.scrollBullet) {
        this.setState({scrollBullet: pane, scrollEndTime: Date.now()});
        this.scrollDirect(pane);
      }
    }
  }

  public componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }


  public render() {
    const {classes} = this.props;

    const pageOne = this.props.isTogether
      ?<div style={{display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '100%',
          justifyContent: 'space-between'}}>
        <div>{tn.lang.implement}</div>
      </div>
      :<ImageFlowContainer scrollTime={this.state.scrollEndTime} viewRef={this.viewRef.current}  hideFAB={this.state.hideFab}/>

    const tabOne = this.props.isTogether
      ?<Tab
        label={
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <div>{"Mat"}</div>
            <div className={classes.badge} style={{display: 'none'}} />
          </div>}
      />
      :<Tab
        label={
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <div>{tn.lang.tabImages}</div>
            <div className={classes.badge} style={{display: (this.props.unseenPosts > 0 ? undefined : 'none')}}>
              {this.props.unseenPosts}
            </div>
          </div>}
      />

    return (<div className={classes.container}>
        <div className={classes.tabs}>
          <div className={this.props.classes.containerTop}>
            <div className={this.props.classes.containerCorners} />
          </div>
          <Tabs
            value={this.state.scrollBullet}
            onChange={(event, value) => {
            const pane = toPaneIndex(value);
            if (pane !== undefined) {
              this.storePane(pane);
              this.scroll(pane);
            }
          }}
            classes={{
              indicator: classes.tabsIndicator
            }}
          >
            {tabOne}
            <Tab
              label={
                <div style={{display: 'flex', flexDirection: 'row'}}>
                  <div>{tn.lang.tabChild}</div>
                </div>}
            />
            <Tab
              label={
                <div style={{display: 'flex', flexDirection: 'row'}}>
                  <div>{tn.lang.sharedSharedAccounts}</div>
                  <div className={classes.badge} style={{display: (this.props.unseenAccounts > 0 ? undefined : 'none')}}>
                    {this.props.unseenAccounts}
                  </div>
                </div>}
            />
          </Tabs>
        </div>
        <div id="infobankwindow"
          className={classes.horizontalController}
          onScroll={() => {
            if (this.timer) {
              clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => this.checkScrollPos(), 200);
        }}>
          <div className={classes.infobankColumn} ref={this.viewRef}
            onScroll={() => {
              if (this.timer) {
                clearTimeout(this.timer);
              }
              this.timer = setTimeout(() => this.checkScrollPos(), 200);
            }}>
            {pageOne}
          </div>
          <div className={classes.infobankColumn}>
            <ChildInfoList/>
          </div>
          <div className={classes.infobankColumn} style={{position: 'relative', overflow: 'hidden'}}>
            <SharedNotesView noteTypes={"ACCOUNTS"} rootClass={classes.infobankColumn} hideFAB={this.state.hideFab}/>
          </div>
        </div>
        <BottomBar 
          hidden={false}
          displaySubmenyCallback={(hideFAB:boolean) => {this.setState({hideFab:hideFAB})}}
        />
      </div>
    );
  }

  private scroll(pane: PaneIndex) {
    const elmnt = document.getElementById("infobankwindow");
    if (elmnt !== null) {
      elmnt.scroll({top: 0, left: ((elmnt.scrollWidth * pane) / 3), behavior: 'smooth'});
    }
  }

  private scrollDirect(pane: PaneIndex) {
    const elmnt = document.getElementById("infobankwindow");
    if (elmnt !== null) {
      elmnt.scrollTop = 0;
      elmnt.scrollLeft = (elmnt.scrollWidth * pane) / 3;
    }
  }

  private checkScrollPos() {
    const elmnt = document.getElementById("infobankwindow");
    if (elmnt !== null) {
      // console.log(elmnt.scrollLeft+"/"+elmnt.scrollWidth);
      if (elmnt.scrollLeft <= elmnt.scrollWidth / 6) {
        this.storePane(0);
      } else if (elmnt.scrollLeft <= (elmnt.scrollWidth*3) / 6) {
        this.storePane(1);
      } else {
        this.storePane(2);
      }
    }
  }

  private storePane(pane: PaneIndex) {
    this.props.setLastInfoPane(pane);
    this.setState({scrollBullet: pane, scrollEndTime: Date.now()});
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const posts: IFlowPost[] = state.posts.posts;
  const sharedStuff: ISharedNote[] = state.notes.sharedNotes?state.notes.sharedNotes:[];

  const sharedAccounts: ISharedNote[] = [];
  let unseenAccounts = 0;

  for (const note of sharedStuff) {
    if (note.accountName !== undefined) {
      sharedAccounts.push(note);
      if (note.seenBy.indexOf(userId) === -1) {
        unseenAccounts++;
      }
    }
  }

  let unseenPosts = 0;
  for (const post of posts) {
    if (post.seen.indexOf(userId) === -1) {
      unseenPosts++;
    }
  }

  let isTogether:boolean = false;
  const myFam = getSelectedFamilyResource(state.user?.session);
  if (myFam !== undefined) {
      isTogether = myFam.familyType === "TOGETHER";
  }

  const lastInfoPane = toPaneIndex(state.ui && state.ui.lastInfoPane);

  return {
    isTogether,
    userId,
    unseenPosts,
    sharedAccounts,
    unseenAccounts,
    lastInfoPane: lastInfoPane !== undefined ? lastInfoPane : 0,
  };
}

const mapDispatchToProps = {
  setLastInfoPane: UiActions.setLastInfoPane,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(infobankStyle)(InfoBankContainer));



// WEBPACK FOOTER //
// ./src/containers/childinfo/infobank.container.tsx